export interface WorkspaceSelections {
  selectedWorkspace: string;
  selectedView: string;
}

export interface SessionDetails {
  sessionExpiryCounter: number;
}

const TenYear = 10 * 365 * 24 * 60 * 60 * 1000;

export class CookieManager {
  public static get<T>(cookieName: string, defaultValue?: T): T {
    if (document.cookie) {
      let name = cookieName + '=';
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          const value = c.substring(name.length, c.length);
          return JSON.parse(decodeURIComponent(value)) as T;
        }
      }
    }
    return defaultValue;
  }

  public static set<T>(cookieName: string, expiresInMillis: number, value: T) {
    var expires = new Date();
    var time = expires.getTime();
    time += expiresInMillis;
    expires.setTime(time);
    document.cookie = `${cookieName}=${encodeURIComponent(
      JSON.stringify(value)
    )};expires=${expires.toUTCString()};SameSite=None;Secure;path=/`;
  }

  public static getWorkspaceSelections<T>(defaultValue?: T): T {
    return CookieManager.get('cpp_plan', defaultValue);
  }

  public static setWorkspaceSelections<T>(value: T) {
    CookieManager.set('cpp_plan', TenYear, value);
  }

  public static getSessionDetails<T>(defaultValue?: T): T {
    return CookieManager.get('cpp_plan_session', defaultValue);
  }

  public static setSessionDetails<T>(value: T) {
    CookieManager.set('cpp_plan_session', TenYear, value);
  }
}

export default CookieManager;
